"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTeamSelect = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var FormTeamSelect = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, teams = _a.teams, label = _a.label, type = _a.type;
    return react_1.default.createElement(storybook_1.Forms.Select, { name: 'team_id', value: video.team_id, onChange: function (team_id) { return setVideo(__assign(__assign({}, video), { team_id: team_id })); }, className: 'flex-1' },
        react_1.default.createElement("option", null, label),
        teams.map(function (team) { return react_1.default.createElement("option", { key: team.id, value: team.id }, type === 'competition' ? team.club.label : team.label); }));
};
exports.FormTeamSelect = FormTeamSelect;
exports.FormTeamSelect.defaultProps = {
    teams: [],
    type: 'competition'
};
